<template>
  <div>
    <div class="totalPayment" style="height: 380px">
      <div class="t-t">
        <div class="t-t-l">
          <div style="text-align: left">回款统计(<span>{{ searchCondition.year }}年</span><span v-if="searchCondition.month">{{
              searchCondition.month
            }}月</span>)
          </div>
          <div><span style="font-size: 12px;color: #999">已执行订单、横坐标为执行时间</span></div>
        </div>
        <div class="t-t-r">
                    <span :class="activeTab=== 1 ?'t-t-r-i total-active':'t-t-r-i'"
                          @click="currentMonth">本月</span>
          <span :class="activeTab=== 2 ?'t-t-r-i total-active':'t-t-r-i'"
                @click="lastMonth">上月</span>
          <span :class="activeTab=== 3 ?'t-t-r-i total-active':'t-t-r-i'"
                @click="currentYear">本年</span>
          <div style="display: inline-block;margin-right: 10px">
            <MonthSelectGroup @selected="selectedMonth"/>
          </div>
          <div style="display: inline-block;margin-right: 10px">
            <YearSelectGroup @selected="selectedYear"/>
          </div>
        </div>
      </div>
      <div class="t-b">
        <div class="t-b-l">
          <div>
            <div>订单总数</div>
            <div class="amount">
              <div v-for="(v,k) in totalPaymentData.all_order_count" :key="all_order_count + k">
                {{ v.label }}:{{ v.value }}
              </div>
            </div>
          </div>
          <div>
            <div>订单总金额（¥）</div>
            <div class="amount">
              <div v-for="(v,k) in totalPaymentData.all_sum_money" :key="all_sum_money + k">
                {{ v.label }}:{{ formatNumber(v.value) }}
              </div>
            </div>
          </div>
          <div>
            <div>未回款金额（¥）</div>
            <div class="amount">
              <div v-for="(v,k) in totalPaymentData.all_sum_remainder_amount" :key="all_sum_remainder_amount + k">
                {{ v.label }}:{{ formatNumber(v.value) }}
              </div>
            </div>
          </div>
          <div>
            <div>已回款金额（¥）</div>
            <div class="amount">
              <div v-for="(v,k) in totalPaymentData.all_sum_amount" :key="all_sum_amount + k">
                {{ v.label }}:{{ formatNumber(v.value) }}
              </div>
            </div>
          </div>
        </div>
        <div id="totalPaymentChart"></div>
      </div>
    </div>
  </div>
</template>

<script>

import {sumPaymentMoney} from "@/api/home";

let echarts = require('echarts')
let myChart
// eslint-disable-next-line no-unused-vars
let length = 16

// eslint-disable-next-line
function resizeFun(e) {
  setLength()
  myChart.resize()
}

function setLength() {
  let width = 0
  if (width > 830) {
    length = 16
  } else if (width >= 720 && width <= 830) {
    length = 14
  } else if (width >= 530 && width < 720) {
    length = 10
  } else if (width < 530) {
    length = 4
  }
}

export default {
  name: "TotalPaymentSummary",
  props: {
    year: [Number, String],
    month: [Number, String],
  },
  data() {
    return {
      activeTab: 1,
      searchCondition: {year: null, month: null},
      totalPaymentData: {} // 回款统计
    }
  },
  created() {
    this.searchCondition.year = this.year
    this.searchCondition.month = this.month
  },
  beforeDestroy() {
    window.removeEventListener('resize', resizeFun)
  },
  methods: {
    selectedYear(val) {
      this.activeTab = null
      this.searchCondition.year = val.year + ''
      this.searchCondition.month = null
      this.showChart()
    },
    selectedMonth(val) {
      this.activeTab = null
      this.searchCondition.year = val.year + ''
      this.searchCondition.month = val.month
      this.showChart()
    },
    currentYear() {
      this.activeTab = 3
      let date = new Date()
      this.searchCondition.year = date.getFullYear()
      this.searchCondition.month = null
      this.showChart()
    },
    lastMonth() {
      this.activeTab = 2
      let date = new Date()
      //分页页面-默认上月
      date.setMonth(date.getMonth() - 1)
      let year = date.getFullYear() + ''
      let month = date.getMonth() + 1;
      this.searchCondition.year = year
      this.searchCondition.month = month
      this.showChart()
    },
    currentMonth() {
      this.activeTab = 1
      let date = new Date()
      //分页页面-默认上月
      // date.setMonth(date.getMonth() - 1)
      let year = date.getFullYear() + ''
      let month = date.getMonth() + 1;
      this.searchCondition.year = year
      this.searchCondition.month = month

      this.showChart()
    },
    handleSearchCondition() {
      let condition = {}
      if (this.searchCondition.year) {
        let year = this.searchCondition.year
        let month = this.searchCondition.month
        if (month) {
          month = parseInt(month)
          let day = new Date(parseInt(year), month, 0);
          let daycount = day.getDate();//最后一天
          condition.start_time = year + '-' + (month > 9 ? month : '0' + parseInt(month + '')) + '-01'
          condition.end_time = year + '-' + (month > 9 ? month : '0' + parseInt(month + '')) + '-' + daycount
          condition.type = 'month'
        } else {
          condition.start_time = year + '-01-01'
          condition.end_time = year + '-12-31'
          condition.type = 'year'
        }
      }

      return condition
    },
    showChart() {
      let cond = this.handleSearchCondition()
      this.getTotal(cond, this.searchCondition.month ? 0 : 1)
    },
    formatNumber(val) {//格式化数据
      return this.gFunc.numberFormat(val, 2, '.', ',')
      // let newNum = ''
      // if (!(val) || val === 0 && val === '0.00' && isNaN(val)) {
      //   newNum = '0'
      //   return newNum;
      // } else {
      //   newNum = parseInt(Number(val).toFixed(0))
      //   return newNum.toLocaleString();
      // }
    },
    getTotal(month, year) {
      sumPaymentMoney(month).then(res => {
        this.totalPaymentData = res.model
        let xAxisData = [], order = [], sum_amount = [], sum_money = [], sum_remainder_amount = []
        res.model.data.forEach((item) => {
          xAxisData.push(item.time)
          order.push(item.order_count)
          sum_amount.push(item.sum_amount)
          sum_money.push(item.sum_money)
          sum_remainder_amount.push(item.sum_remainder_amount)
        })
        myChart = echarts.init(document.getElementById('totalPaymentChart'));
        myChart.setOption({
          grid: {
            left: '5%',
            right: '4%',
            bottom: '8%',
          },
          title: {
            text: year ? month.start_time.substring(0, 4) + '年' : month.start_time.substring(0, 7),
            x: '5%',
            y: 'top',
            textStyle: {
              fontSize: 12,
              color: '#595959',
              fontWeight: 400
            }
          },
          color: ['#86B9FF', '#FF8686', '#AC8EE3', '#FFD980'],
          tooltip: {
            trigger: 'axis'
          },
          legend: {
            left: '10%',
            itemWidth: 10,
            itemHeight: 10,
            data: [
              {
                name: '订单量',
                icon: 'roundRect',
                textStyle: {
                  fontSize: 12,
                  color: '#595959'
                }
              },
              {
                name: '订单总额',
                icon: 'roundRect',
                textStyle: {
                  fontSize: 12,
                  color: '#595959'
                }
              },
              {
                name: '未回款金额',
                icon: 'roundRect',
                textStyle: {
                  fontSize: 12,
                  color: '#595959'
                }
              },
              {
                name: '已回款金额',
                icon: 'roundRect',
                textStyle: {
                  fontSize: 12,
                  color: '#595959'
                }
              }
            ]
          },
          xAxis: {
            axisLine: {
              lineStyle: {
                color: '#B6B6B6',
              }
            },
            data: xAxisData
          },
          yAxis: [
            {
              type: 'value',
              name: '万元',
              min: 0,
              axisLabel: {
                formatter: (value) => {
                  return Number(value) / 10000
                },
                textStyle: {
                  color: '#B6B6B6'
                }
              },
              splitLine: {
                show: false,
              },
              axisLine: {
                lineStyle: {
                  color: '#B6B6B6',
                }
              },
            },
            {
              type: 'value',
              name: '单',
              min: 0,
              interval: 50,
              axisLabel: {
                formatter: '{value}',
                textStyle: {
                  color: '#B6B6B6'
                }
              },
              splitLine: {
                show: false,
              },
              axisLine: {
                lineStyle: {
                  color: '#B6B6B6',
                }
              },
            }
          ],
          series: [
            {
              barWidth: '10',
              name: '订单量',
              type: 'bar',
              yAxisIndex: 1,
              data: order
            },
            {
              barWidth: '10',
              name: '订单总额',
              type: 'bar',
              yAxisIndex: 0,
              data: sum_money
            },
            {
              barWidth: '10',
              name: '未回款金额',
              type: 'bar',
              yAxisIndex: 0,
              data: sum_remainder_amount
            },
            {
              barWidth: '10',
              name: '已回款金额',
              type: 'bar',
              yAxisIndex: 0,
              data: sum_amount
            }
          ]
        });
      })
    },
  }
}
</script>

<style scoped>
.title {
  text-align: left;
  padding-left: 20px;
}

.total, .customer, .fboy, .sale, .excu, .platform, .totalPayment {
  height: 380px;
  background: #fff;
  padding: 24px;
  box-sizing: border-box;
}

.customer, .fboy, .sale, .excu, .platform, .totalPayment {
  height: 860px;
  margin: 10px 0;
}

.t-t, .t-b {
  display: grid;
  grid-template-columns: 15% 85%;
  justify-items: left;
}

.t-t {
  grid-template-rows: 50px;
  align-items: center;
}

.t-b {
  grid-template-rows: 280px;
}

.t-t-r-i {
  margin: 0 24px;
  height: 40px;
  display: inline-block;
  line-height: 40px;
  cursor: pointer;
}

.total-active {
  color: #3296FF;
  border-bottom: 2px solid #3296FF;
}

.amount {
  font-weight: 400;
  color: rgba(50, 150, 255, 1);
  padding-top: 10px;
  /* font-size: 20px; */
}

.t-b-l {
  display: grid;
  align-content: space-evenly;
  justify-content: left;
  padding-left: 20px;
}

.t-b-l > div {
  text-align: left;
}

#totalPaymentChart {
  width: calc((100vw - 0px - 48px) * 0.85);
  height: calc(380px - 48px - 50px);
}

.line-rr > .t-t-r {
  text-align: left;
}
</style>
